import { useQuery } from '@tanstack/react-query';
import {
  publicEntityLookupSearch,
  publicEntityLookupGetById,
  PublicEntityLookupParams,
} from '@/modules/shared/services/selfRegistrationService';

export const publicEntityLookupKeys = {
  all: ['publicEntityLookup'] as const,
  search: (programCode: string, entityType: string, params: PublicEntityLookupParams) =>
    [...publicEntityLookupKeys.all, 'search', programCode, entityType, params] as const,
  detail: (programCode: string, entityType: string, entityId: string) =>
    [...publicEntityLookupKeys.all, 'detail', programCode, entityType, entityId] as const,
};

/**
 * Public (no-auth) entity search for self-registration entity selector fields.
 */
export function usePublicEntityLookup(
  programCode: string | undefined,
  entityType: string | undefined,
  params: PublicEntityLookupParams = {},
  enabled = true
) {
  return useQuery({
    queryKey: publicEntityLookupKeys.search(programCode!, entityType!, params),
    queryFn: () => publicEntityLookupSearch(programCode!, entityType!, params),
    enabled: !!programCode && !!entityType && enabled,
    staleTime: 30_000,
  });
}

/**
 * Public (no-auth) entity get by ID for display resolution.
 */
export function usePublicEntityById(
  programCode: string | undefined,
  entityType: string | undefined,
  entityId: string | undefined
) {
  return useQuery({
    queryKey: publicEntityLookupKeys.detail(programCode!, entityType!, entityId!),
    queryFn: () => publicEntityLookupGetById(programCode!, entityType!, entityId!),
    enabled: !!programCode && !!entityType && !!entityId,
    staleTime: 60_000,
  });
}
